import React, { useState } from "react";
import ArrowRightIcon from "@/assets/icons/arrow-right.svg";
import WalletIcon from "@/assets/icons/wallet.svg";
import { Button } from "@/app/(components)/Basic/Button";
import { Nft } from "@/api/nfts/types";

import { OrderType, SignedSaleOrder } from "@/api/orders/types";
import { NftCompletePurchaseModal } from "../../../Nft/NftCompletePurchaseModal";
import useWithCorrectNetwork from "@/shared/hooks/useWithCorrectNetwork";
import { useSuccessModal } from "@/app/(components)/Basic/SuccessModal/context/context";
import useMe from "@/shared/hooks/useMe";
import { isExpiredInSeconds } from "@/shared/dates";
import { isUserPrivateAuctionParticipant } from "../../TradeActions/helpers";

export interface Props {
  nft: Nft;
  auction: SignedSaleOrder;
  disable?: boolean;
}

export default function BuyNowButton({ nft, auction, disable }: Props) {
  const [isPurchaseConfirm, setIsPurchaseConfirm] = useState<boolean>(false);

  const { setSuccessData } = useSuccessModal();

  const { me: user } = useMe();

  const checkedPurchaseConfirm = useWithCorrectNetwork(() =>
    setIsPurchaseConfirm(true),
  );

  const canUserAccessPrivateAuction = isUserPrivateAuctionParticipant(
    user!,
    auction,
  );

  const onSuccess = async () => {
    await setSuccessData({
      item: {
        name: nft.name,
        media: nft.thumbnail!,
        mediaWidth: nft.imageWidth,
        mediaHeight: nft.imageHeight,
        mediaType: nft.mediaType,
        placeholder: nft.placeholder,
      },
      title: "Congratulations",
      text: "Your transaction is successful!",
      buttonText: "View your artwork",
      redirectUrl: `/nft/${nft.id}`,
    });

    setIsPurchaseConfirm(false);
  };

  const isExpired = auction ? isExpiredInSeconds(auction.expiresAt) : false;

  return (
    <>
      <Button
        disabled={
          !auction ||
          disable ||
          (auction.type === OrderType.PRIVATE_AUCTION &&
            !canUserAccessPrivateAuction) ||
          isExpired
        }
        onClick={checkedPurchaseConfirm}
        className="-bottom-20 mt-10 lg:mt-0 lg:absolute"
        startIcon={<WalletIcon />}
        endIcon={<ArrowRightIcon className="w-4" />}
      >
        Buy now
      </Button>
      {canUserAccessPrivateAuction && isExpired && (
        <span className="text-red text-lg -bottom-[110px] mt-2 lg:mt-0 lg:absolute">
          Sale Expired
        </span>
      )}
      {isPurchaseConfirm ? (
        <NftCompletePurchaseModal
          nft={nft}
          auction={auction}
          onSuccess={onSuccess}
          onClose={() => setIsPurchaseConfirm(false)}
        />
      ) : null}
    </>
  );
}
